"use strict";

import Page from "./MyAccount.jsx";

export const auth = true;
export const title = "i18n:myAccount.accountInformation";
export const Component = Page;
